import { useState } from 'react';
import {
  HeaderSearchForm,
  HeaderCategoryMenu,
  HeaderCategoryMenuCategories,
  RightTriangleIcon,
  HamburgerIcon,
  CrossIcon,
} from '@components';
import { title } from '@constants';
import {
  interviewBasePath,
  casestudyListPath,
  basePath,
  buyerContactPath,
  developerEntryPath,
  adSaasPath,
} from '@paths';
import LogoLounge from '@images/logo-lounge.png';
import LogoNavi from '@images/hnavi-logo.png';
import { addTrailingSlash } from '@utils';
import Image from 'next/legacy/image';

export const LogoWrapper: React.FC<{
  h1?: boolean;
  className?: string;
  children: any;
}> = ({ h1, className, children }) =>
  h1 ? (
    <h1 className={className}>{children}</h1>
  ) : (
    <div className={className}>{children}</div>
  );

export const Header: React.FC<{
  categories?: HeaderCategoryMenuCategories | null;
  wrapLogoByH1Tag?: boolean;
}> = ({ categories, wrapLogoByH1Tag }) => {
  const [open, setOpen] = useState(false);

  return (
    <>
      <nav className='fixed z-20 mb-4 h-[54px] w-full bg-lightgray pt-4 shadow-md lg:mb-8 lg:h-[104px]'>
        <div className='container mx-auto mb-4 hidden px-5 lg:block'>
          <div>
            <ul className='flex justify-end gap-5 font-bold'>
              <li>
                <a
                  href={addTrailingSlash(developerEntryPath)}
                  className='flex items-center gap-1 text-top-primary hover:text-primary'
                >
                  <RightTriangleIcon className='h-4' />
                  開発会社の方はこちら
                </a>
              </li>
              <li>
                <a
                  href={addTrailingSlash(adSaasPath)}
                  className='flex items-center gap-1 text-top-primary hover:text-primary'
                >
                  <RightTriangleIcon className='h-4' />
                  SaaS・IT製品ベンダーの方はこちら
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className='container mx-auto px-5 lg:flex lg:items-end'>
          <div className='flex items-center justify-between'>
            <div className='flex items-end'>
              <LogoWrapper
                h1={wrapLogoByH1Tag}
                className='w-[147px] lg:w-[200px]'
              >
                <a href={basePath}>
                  <Image
                    src={LogoLounge}
                    alt={title}
                    width={LogoLounge.width}
                    height={LogoLounge.height}
                  />
                </a>
              </LogoWrapper>
              <div className='ml-2 hidden items-end gap-1 min-[340px]:flex'>
                <span className='text-xs text-darkgray'>by</span>
                <a href='/' className='w-[100px]'>
                  <Image
                    loader={(p) => p.src}
                    src={LogoNavi}
                    alt='発注ナビ'
                    width={LogoNavi.width}
                    height={LogoNavi.height}
                    loading='lazy'
                  />
                </a>
              </div>
            </div>

            <button
              onClick={() => {
                setOpen((prev) => !prev);
              }}
              className='relative h-8 w-8 text-top-primary hover:opacity-75 lg:hidden'
              aria-label='メニュー'
            >
              <HamburgerIcon
                className={`absolute inset-0 transition-opacity ${
                  open ? 'opacity-0' : ''
                }`}
              />
              <CrossIcon
                className={`absolute inset-0 transition-opacity ${
                  !open ? 'opacity-0' : ''
                }`}
              />
            </button>
          </div>

          <div
            className={`fixed left-0 right-0 ml-auto flex-col items-end gap-5 bg-lightgray px-4 py-5 lg:static lg:flex lg:flex-row lg:items-center lg:px-0 lg:py-0 ${
              open ? 'flex' : 'hidden'
            }`}
          >
            <div className='w-full lg:hidden'>
              <HeaderSearchForm />
            </div>
            {categories && <HeaderCategoryMenu categories={categories} />}
            <a
              href={addTrailingSlash(interviewBasePath)}
              className='font-bold transition-opacity hover:opacity-80'
            >
              インタビュー
            </a>
            <a
              href={addTrailingSlash(casestudyListPath())}
              className='font-bold transition-opacity hover:opacity-80'
            >
              発注事例
            </a>
            <a
              href={addTrailingSlash(
                casestudyListPath('corporation-casestudy')
              )}
              className='font-bold transition-opacity hover:opacity-80'
            >
              開発会社事例
            </a>

            <div className='hidden lg:block'>
              <HeaderSearchForm popup />
            </div>

            <a
              href={addTrailingSlash(buyerContactPath)}
              className='whitespace-nowrap rounded-lg bg-hnavi-orange px-6 py-2 font-bold text-white hover:opacity-75'
            >
              発注先のご相談
            </a>

            <a
              href={addTrailingSlash(developerEntryPath)}
              className='flex items-center gap-1 font-bold text-top-primary hover:text-primary lg:hidden'
            >
              <RightTriangleIcon className='h-4' />
              開発会社の方はこちら
            </a>

            <a
              href={addTrailingSlash(adSaasPath)}
              className='flex items-center gap-1 font-bold text-top-primary hover:text-primary lg:hidden'
            >
              <RightTriangleIcon className='h-4' />
              SaaS・IT製品ベンダーの方はこちら
            </a>
          </div>
        </div>
      </nav>
      <div className='mb-4 h-[54px] lg:mb-8 lg:h-[104px]' />
    </>
  );
};

export default Header;
